import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (userId) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://dev.invoge.com/backend/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json();
      if (result.status === 'success') {
        alert('Login successful!');
        console.log(`Logged in with user ID: [${result.userId}]`);

        // Store all user details in localStorage
        localStorage.setItem('userId', result.userId);
        localStorage.setItem('unique_username', result.unique_username);
        localStorage.setItem('subscription_level', result.subscription_level);
        localStorage.setItem('docs_count', result.docs_count);
        localStorage.setItem('docs_count_max', result.docs_count_max);

        setIsLoggedIn(true);
        navigate('/profile'); // Redirect to profile page
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const handleLogout = () => {
    localStorage.clear(); // Clear all user data
    setIsLoggedIn(false);
    navigate('/login'); // Redirect to login page
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        {isLoggedIn ? (
          <>
            <h1>Welcome Back!</h1>
            <p>You are already logged in.</p>
            <button onClick={handleLogout}>Logout</button>
          </>
        ) : (
          <>
            <h1>Login</h1>
            <form onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button type="submit">Login</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
